import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../../lib/admin-api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [whitelist, setWhitelist] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [s, w] = await Promise.all([
          adminApi.get("/stats"),
          adminApi.get("/whitelist"),
        ]);
        setStats(s.data);
        setWhitelist(w.data.admin_emails || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const tiles = stats ? [
    { label: "Klassiekers (totaal)", value: stats.classics_total, testid: "stat-classics-total" },
    { label: "Klassiekers (zichtbaar)", value: stats.classics_visible, testid: "stat-classics-visible" },
    { label: "Ruimtes", value: stats.rooms_total, testid: "stat-rooms" },
    { label: "Projecten (zichtbaar)", value: `${stats.projects_visible} / ${stats.projects_total}`, testid: "stat-projects" },
  ] : [];

  return (
    <div data-testid="admin-dashboard" className="max-w-5xl">
      <div className="text-xs uppercase tracking-[0.3em] text-stoel-walnut mb-3">— Overzicht</div>
      <h1 className="stoel-display text-4xl md:text-5xl mb-2">Dashboard</h1>
      <p className="text-stoel-inkSoft mb-12">
        Welkom terug. Hier kunt u inhoud beheren, AI-vulling gebruiken voor nieuwe stukken, en de afwerking van de site afstemmen.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
        {tiles.map((t) => (
          <div key={t.label} data-testid={t.testid} className="bg-stoel-paper border border-stoel-line p-6">
            <div className="text-xs uppercase tracking-[0.2em] text-stoel-walnut mb-3">{t.label}</div>
            <div className="text-3xl font-light text-stoel-ink tabular-nums">{t.value}</div>
          </div>
        ))}
      </div>

      <section className="grid md:grid-cols-2 gap-6 mb-16">
        <Link to="/admin/classics" data-testid="quick-classics" className="block bg-stoel-paper border border-stoel-line p-6 hover:border-stoel-ink transition-colors">
          <div className="stoel-eyebrow mb-2">Klassiekers</div>
          <div className="text-lg font-light">Beheer, toevoegen & AI-vulling</div>
        </Link>
        <Link to="/admin/projects" data-testid="quick-projects" className="block bg-stoel-paper border border-stoel-line p-6 hover:border-stoel-ink transition-colors">
          <div className="stoel-eyebrow mb-2">Recente Projecten</div>
          <div className="text-lg font-light">Klant-testimonials & beelden</div>
        </Link>
      </section>

      <section className="bg-stoel-paper border border-stoel-line p-6">
        <div className="stoel-eyebrow mb-3">Admin whitelist</div>
        <ul className="space-y-1.5 text-sm font-mono">
          {whitelist.map((e) => <li key={e} className="text-stoel-ink">{e}</li>)}
        </ul>
        <p className="mt-3 text-xs text-stoel-inkSoft">
          Lijst wordt momenteel beheerd via de server-omgeving (ADMIN_EMAILS).
        </p>
      </section>
    </div>
  );
}
